"use client";

import Hero from "@/components/hero/hero";

const Home = () => {
  return <Hero />;
};

export default Home;
